import { c as _c } from "react/compiler-runtime";
import React from "react";
import { GiphyGif } from "../types/giphy";
import GifCard from "./GifCard";
import styles from "./GifGrid.module.css";
interface GifGridProps {
  gifs: GiphyGif[];
  onCopy: (url: string) => void;
}
export default React.memo(function GifGrid(t0) {
  const $ = _c(8);
  const {
    gifs,
    onCopy
  } = t0;
  if (gifs.length === 0) {
    return null;
  }
  const isSmallSet = gifs.length <= 3;
  const t1 = `${styles.grid} ${isSmallSet ? styles.centered : ""}`;
  let t2;
  if ($[0] !== gifs || $[1] !== onCopy) {
    let t3;
    if ($[3] !== onCopy) {
      t3 = gif => <GifCard key={gif.id} gif={gif} onCopy={onCopy} />;
      $[3] = onCopy;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    t2 = gifs.map(t3);
    $[0] = gifs;
    $[1] = onCopy;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div className={t1} role="grid">{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
});